import { takeLatest, put, call, select } from 'redux-saga/effects';
import { CLOSE_WORKOUT_SAGA } from "../sagaTypes";
import { loaderAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { currentVisitorsSagaAction } from "../sagaActions";

const request = data => {
    return fetch(`${ url }/close_workout`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerCloseWorkout(args) {
    const user = yield select(state => state.user);
    const currentEstablishment = yield select(state => state.currentEstablishment);
    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);
        formData.append('workout_id', args.data.workout_id);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            growl({ type: 'success', message: response.message });
            // Запрашиваем новый список с текущими пользователями
            yield put(currentVisitorsSagaAction({ establishment: currentEstablishment }));
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherCloseWorkout() {
    yield takeLatest(CLOSE_WORKOUT_SAGA, workerCloseWorkout);
}